import { useEffect } from "react";

/** Every page in this app scrolls to the top on mount. */
const useScrollTop = (deps = []) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useScrollTop;
